import { CLIENT_PAGES } from '@/constants/clientPortalPages'
import { normalizeClientId } from '@/utilities/auth/authHelper'

/**
 * Multi-program (org) dashboard URL. `org` is the organization's primary partner id.
 * Clears `partners` so only one context is represented.
 */
export function buildOrgDashboardUrl(primaryPartnerId: string): string {
  const orgId = normalizeClientId(primaryPartnerId.trim())
  const params = new URLSearchParams()
  params.set('org', orgId)
  return `${CLIENT_PAGES.dashboard}?${params.toString()}`
}

/**
 * Single-program dashboard URL from the header switcher.
 * Clears `org` so only program context is represented. Intentionally minimal
 * (partners only) so navbar switches reset date/view filters, unlike
 * in-dashboard client switches that preserve them via `buildProgramClientSwitchSearchQuery`.
 */
export function buildProgramContextDashboardUrl(partnerId: string): string {
  const id = normalizeClientId(partnerId.trim())
  const params = new URLSearchParams()
  params.set('partners', id)
  return `${CLIENT_PAGES.programDashboard}?${params.toString()}`
}
